module.exports = __webpack_public_path__ + "img/collaboratori-image-1.62ba96d2.png";